<script>
import { mapActions } from "vuex";

export default {
  data: function () {
    return {
      series: [],
      chartOptions: {
        chart: {
          height: 500,
          type: "radialBar",
          toolbar: {
            show: false,
            tools: {
              download: true
            }
          },
          /* offsetX: 270 */
        },
        plotOptions: {
          radialBar: {
            track: {
              background: "#a7d1b5",
            },
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 15,
              size: "20%",
              background: "transparent",
              image: undefined,
              position: "front",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
            maxValue: 5
          },
        },
        colors: [
          "#366345",
          "#2E6B42",
          "#267340",
          "#1F7A3D",
          "#17823B",
          "#0F8A38",
          "#089136",
          "#009933",
        ],
        labels: [],
        legend: {
          show: false,
          floating: true,
          fontSize: "19px",
          position: "left",
          offsetX: 30,
          offsetY: -295,
          labels: {
            useSeriesColors: true,
          },
          itemMargin: {
            vertical: 1,
          },
          /* formatter: function (seriesName, opts) {
            return [
              seriesName,
              ": ",
              Math.round(opts.w.globals.series[opts.seriesIndex]),
            ];
          }, */
        },
        onItemHover: {
          highlightDataSeries: true,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: true,
              },
            },
          },
        ],
      },
    };
  },

  created() {
    this.getGreenDeal();
  },
  props: {
    selectedSurveyID: null,
  },
  methods: {
    ...mapActions("results", ["greenDeal"]),
    findLargestInteger(arr) {
      let largest = arr[0];
      for (let i = 1; i < arr.length; i++) {
        if (arr[i] > largest) {
          largest = arr[i];
        }
      }
      return largest;
    },
    async getGreenDeal() {
      let counts_list = [];

      let params = {
        company_id: this.$user.company_id,
        is_deleted: false,
        su1_survey_id: this.selectedSurveyID,
      };
      this.greenDeal(params)
        .then((response) => {
          response.data.greenDealsSelectionCounts.forEach(item => {
            counts_list.push(item.selectionCount);
          });
          const maxCount = this.findLargestInteger(counts_list);
          response.data.greenDealsSelectionCounts.forEach((item) => {
            this.series.push(item.selectionCount*100/maxCount);
            this.chartOptions.labels.push(`${item.greenDealName}: ${item.selectionCount}`);
          });
          counts_list.length = 0;
        })
        .catch(({ response }) => {
          this.$toast.open({
            message: this.$parseResMessage(response.data.messageName),
            type: "error",
            duration: 5000,
            dismissible: true,
          });
        });
    },
  },
};
</script>

<template>
  <apex-chart
    type="radialBar"
    :options="chartOptions"
    :series="series"
  />
</template>